// 科目类型
export type SubjectType = 'chinese' | 'math' | 'english';

// 好评数据接口
export interface TrustpilotReview {
  id: number;
  name: string; // 姓名
  date: string; // 日期 (格式: "Apr 26, 2025")
  region: string; // 地区
  rating: number; // 星级 (1-5)
  comment: string; // 评论内容
  link: string; // Trustpilot 链接
  subjects: SubjectType[] | 'all'; // 适用科目，'all' 表示所有科目
}

// 30条好评数据
export const trustpilotReviews: TrustpilotReview[] = [
  {
    id: 1,
    name: 'John Scales',
    date: 'Apr 26, 2025',
    region: 'Australia',
    rating: 5,
    comment:
      "Their course design is well thought-out, highly interactive, and my child learns Chinese in an actually fun and relaxed environment! We're really proud of his progress!",
    link: 'https://www.trustpilot.com/reviews/680c2eff2d8673eaa585105c',
    subjects: ['chinese'],
  },
  {
    id: 2,
    name: 'Kreenapat Akanaphaibul',
    date: 'Apr 29, 2025',
    region: 'Thailand',
    rating: 5,
    comment:
      'My 6-year-old son finds it easy to follow. His teacher is very patient and uses good techniques to help young learners participate.',
    link: 'https://www.trustpilot.com/users/602f882fd37e8b001a2b1e47',
    subjects: 'all',
  },
  {
    id: 3,
    name: 'Eric Phung',
    date: 'May 16, 2025',
    region: 'New Zealand',
    rating: 5,
    comment:
      'Very responsible and helpful. The teacher is very knowledgeable and patient.',
    link: 'https://www.trustpilot.com/users/68270cc85ad665f6a94f1298',
    subjects: 'all',
  },
  {
    id: 4,
    name: 'Qi Lou',
    date: 'May 19, 2025',
    region: 'United States',
    rating: 5,
    comment: 'Clear guidance and a great text book!',
    link: 'https://www.trustpilot.com/reviews/682b4c5ebb461e7717dd9447',
    subjects: 'all',
  },
  {
    id: 5,
    name: 'Tennille Jacobs',
    date: 'March 6, 2025',
    region: 'Canada',
    rating: 5,
    comment:
      'A truly thoughtful and engaging experience for young beginner Chinese learners!',
    link: 'https://www.trustpilot.com/users/6818db45bf768b4f42ee640d',
    subjects: ['chinese'],
  },
  {
    id: 6,
    name: 'Eva Lin',
    date: 'Feb 10, 2026',
    region: 'United States',
    rating: 5,
    comment: 'Great teachers! The teachers are very nice and patient. ',
    link: 'https://www.trustpilot.com/reviews/698a1d427ebee405d3415aa2',
    subjects: 'all',
  },
  {
    id: 7,
    name: 'Edward Ferguson',
    date: 'Apr 24, 2025',
    region: 'Singapore',
    rating: 5,
    comment:
      "It's both educational and enjoyable. The teachers are also very friendly, and my child loves their Chinese lessons!",
    link: 'https://www.trustpilot.com/users/680a06542203742056288966',
    subjects: ['chinese'],
  },
  {
    id: 8,
    name: 'Carrie Manseau',
    date: 'Apr 22, 2025',
    region: 'Singapore',
    rating: 5,
    comment:
      'Since my child started with WuKong, a huge boost in her confidence when speaking Chinese.',
    link: 'https://www.trustpilot.com/users/6806f361fa40066bcca0011e',
    subjects: ['chinese'],
  },
  {
    id: 9,
    name: 'Athina',
    date: 'Feb 3, 2026',
    region: 'Belgium',
    rating: 5,
    comment:
      'My daughter has just started her Chinese lessons, but we are already excited with the excellent communication, the way the whole think works, the great choice of teachers, hours etc... everything is perfect! ',
    link: 'https://www.trustpilot.com/reviews/6981f6673cae6ebfaaaf6077',
    subjects: ['chinese'],
  },
  {
    id: 10,
    name: 'Edward Camper',
    date: 'Apr 22, 2025',
    region: 'Canada',
    rating: 5,
    comment:
      'The courses are rich in content, covering grammar, vocabulary, speaking and more.',
    link: 'https://www.trustpilot.com/users/68079e8bbbc62341f0071b50',
    subjects: ['chinese', 'english'],
  },
  {
    id: 11,
    name: 'Michelle Bux',
    date: 'Jan 19, 2026',
    region: 'United States',
    rating: 5,
    comment:
      'The organization is very professional and well-structured. The coordinators are extremely attentive and supportive!',
    link: 'https://www.trustpilot.com/reviews/696d078b67cd3cc53de415a1',
    subjects: 'all',
  },
  {
    id: 12,
    name: 'Tofunmi',
    date: 'Jan 18, 2026',
    region: 'United Kingdom',
    rating: 5,
    comment:
      "All the people I've spoken too were all so nice and cheerful! The first lesson I had started with a fun action imitation game and there were lots of activities implemented in each lesson.",
    link: 'https://www.trustpilot.com/reviews/696bdb681b7b1f95acb0e462',
    subjects: 'all',
  },
  {
    id: 13,
    name: 'Bobby Lewis',
    date: 'Jan 30, 2025',
    region: 'United States',
    rating: 5,
    comment:
      'My son has been with WuKong Math for six months and has made great progress. Highly recommended!',
    link: 'https://www.trustpilot.com/users/679b4c43b683e91d6c105b77',
    subjects: ['math'],
  },
  {
    id: 14,
    name: 'Angela L.',
    date: 'Feb 8, 2025',
    region: 'Australia',
    rating: 5,
    comment: 'Really impressed by the teachers at WuKong Math!',
    link: 'https://www.trustpilot.com/users/677db461b59e5f63177c927e',
    subjects: ['math'],
  },
  {
    id: 15,
    name: 'Ming',
    date: 'Dec 15, 2025',
    region: 'Australia',
    rating: 5,
    comment:
      'Good service and good vivid class interaction teacher and student! Easy to follow!',
    link: 'https://www.trustpilot.com/reviews/693f8565d7f0aa6c50fbea25',
    subjects: 'all',
  },
  {
    id: 16,
    name: 'Kendy Choi',
    date: 'Nov 28, 2025',
    region: 'Belgium',
    rating: 5,
    comment: 'Efficient and fun learning through gamification method.',
    link: 'https://www.trustpilot.com/reviews/6930380f87c8c9c454521cbc',
    subjects: 'all',
  },
  {
    id: 17,
    name: 'Sheila C',
    date: 'Oct 31, 2025',
    region: 'Singapore',
    rating: 5,
    comment:
      'From trial to purchasing the credits package, everything was smooth. Great customer service support after sales too. Smooth and Fuss Free in collecting gifts from Singapore operation team too.',
    link: 'https://www.trustpilot.com/reviews/690f552c17d4767ca305f226',
    subjects: 'all',
  },
  {
    id: 18,
    name: 'Aisling Mac Sweeney',
    date: 'Sep 27, 2025',
    region: 'United Kingdom',
    rating: 5,
    comment:
      'We tried a few different providers and it was clear from the trial lesson that WuKong had the most structured and clear resources. ',
    link: 'https://www.trustpilot.com/reviews/68e240d1fd0a5ef6bb14acc7',
    subjects: 'all',
  },
  {
    id: 19,
    name: 'Crystal Yuan',
    date: 'Oct 2, 2024',
    region: 'Germany',
    rating: 5,
    comment:
      'My kid really enjoys the classes at WuKong. He has both English and Math classes. From WuKong he got extra ideas on how to learn and how to solve problems, which made him better perform with higher confidence at his school :)',
    link: 'https://www.trustpilot.com/users/66fc3c702a34cb4f2b01a4cf',
    subjects: ['math', 'english'],
  },
  {
    id: 20,
    name: 'Lisa Wang',
    date: 'Jul 24, 2024',
    region: 'Canada',
    rating: 5,
    comment:
      'WuKong is very great education platform. My two kids learnt Chinese, Math and English on the platform more than 5 years!',
    link: 'https://www.trustpilot.com/users/66a07bffeee4cfe65977d775',
    subjects: 'all',
  },
  {
    id: 21,
    name: 'Harry F.',
    date: 'Feb 8, 2025',
    region: 'Singapore',
    rating: 5,
    comment:
      "My son loves his English lessons with WuKong! The teacher is professional and always keeps him engaged. He's made noticeable progress in his reading and speaking skills.",
    link: 'https://www.trustpilot.com/users/67a66be98921763aff45fd94',
    subjects: ['english'],
  },
  {
    id: 22,
    name: 'Cindy',
    date: 'Aug 30, 2025',
    region: 'New Zealand',
    rating: 5,
    comment:
      'Very efficient and helpful teacher. The app and teaching platform is good and easy to use.',
    link: 'https://www.trustpilot.com/reviews/68bd7ca454c59a1e2d09e0e0',
    subjects: 'all',
  },
  {
    id: 23,
    name: 'Athina E. F.',
    date: 'Apr 17, 2025',
    region: 'United States',
    rating: 5,
    comment: 'Flexible, fun and engaging. One year in and still going strong!',
    link: 'https://www.trustpilot.com/reviews/680041164089f40e6cf15746',
    subjects: 'all',
  },
  {
    id: 24,
    name: 'Joshua Goodwin',
    date: 'Apr 17, 2025',
    region: 'Australia',
    rating: 5,
    comment:
      'Every lesson includes cultural insights, helping my child understand the richness of Chinese culture.',
    link: 'https://www.trustpilot.com/users/67ffdd96a8b3e6018c9d1436',
    subjects: ['chinese'],
  },
  {
    id: 25,
    name: 'Griffin Tate',
    date: 'Jul 25, 2025',
    region: 'United States',
    rating: 5,
    comment:
      'My boy has been learning with WuKong for 3 years now, and the progress has been incredible! ',
    link: 'https://www.trustpilot.com/reviews/6885c547718a413d8284d5a9',
    subjects: 'all',
  },
  {
    id: 26,
    name: 'Bernadette Ortiz',
    date: 'Apr 13, 2025',
    region: 'United States',
    rating: 5,
    comment: 'Perfect balance between learning and fun.',
    link: 'https://www.trustpilot.com/users/67fb42fdfa400607b8946dc3',
    subjects: 'all',
  },
  {
    id: 27,
    name: 'Christopher Rivas',
    date: 'Apr 10, 2025',
    region: 'United States',
    rating: 5,
    comment:
      'My child feels comfortable asking questions and participating without fear of making mistakes.',
    link: 'https://www.trustpilot.com/users/67f7882aa8b3e6636f93f943',
    subjects: 'all',
  },
  {
    id: 28,
    name: 'RC',
    date: 'Mar 30, 2025',
    region: 'New Zealand',
    rating: 5,
    comment:
      'Great teaching and follow up after each lesson. My son is finding it encouraging and motivating to go to class.',
    link: 'https://www.trustpilot.com/reviews/67e90aebbdfd461ce7ef4c0e',
    subjects: 'all',
  },
  {
    id: 29,
    name: 'Irina',
    date: 'Mar 26, 2025',
    region: 'United Kingdom',
    rating: 5,
    comment:
      'My son is 5 and he loves the classes are tailored for him with a lot of interaction between him and the teacher.',
    link: 'https://www.trustpilot.com/users/576417720000ff000a2a26e5',
    subjects: 'all',
  },
  {
    id: 30,
    name: 'Renny West',
    date: 'Feb 5, 2025',
    region: 'United Kingdom',
    rating: 5,
    comment:
      "Their service is exceptional, always going above and beyond to support our child's learning journey.",
    link: 'https://www.trustpilot.com/users/67a256a31368429cb0f170c6',
    subjects: 'all',
  },
];

// ============================================
// 学生案例数据
// ============================================

/**
 * 学生案例数据接口
 * 用于展示真实学生故事模块
 */
export interface StudentCase {
  id: number;
  image: string; // 学生照片路径
  rating: number; // 星级 1-5
}

/**
 * 学生案例 ID 列表
 * 用于遍历渲染，文案从 i18n wallOfLove.json 获取
 */
export const STUDENT_CASE_IDS = [1, 2, 3, 4, 5];

/**
 * 学生案例数据
 * 图片路径和星级（文案从 i18n 获取）
 */
export const studentCases: StudentCase[] = [
  {
    id: 1,
    image: '/images/wukong-reviews/case-1.png',
    rating: 5,
  },
  {
    id: 2,
    image: '/images/wukong-reviews/case-2.png',
    rating: 5,
  },
  {
    id: 3,
    image: '/images/wukong-reviews/case-3.png',
    rating: 5,
  },
  {
    id: 4,
    image: '/images/wukong-reviews/case-4.png',
    rating: 5,
  },
  {
    id: 5,
    image: '/images/wukong-reviews/case-5.png',
    rating: 5,
  },
];
